import React from "react";
import img from "../../assets/img/Standard-Internal-Circlips-Metric-diagram.png";

const SingleCategory = () => {
  const category = {
    catname: "Web Development",
    details:
      "Explore the world of web development with our comprehensive resources and courses.",
    image: img,
  };

  return (
    <div className="text-center w-full overflow-x-hidden">
      <div className="mx-auto max-w-7xl pb-10">
        <p className="font-semibold tracking-tight text-gray-900 text-3xl text-start font-bold">
          Standard Internal Circlips: To DIN 472 Metric
        </p>

        {/* Flex Container for Sidebar + Image */}
        <div className="flex flex-col lg:flex-row items-start gap-10">
          {/* Sidebar Content Box */}
          {/* Right Image */}
          <div className="flex-1">
            <img
              alt="Web Development"
              src={category.image}
              className="w-full h-auto max-h-[300px] object-contain p-5"
            />
            <div className="w-full bg-white p-0 text-start">
              {/* <h2 className="text-2xl font-semibold mb-6 text-gray-800">
                Product Details
              </h2> */}
              <p className="text-[#969696] mb-4 font-[400]">
                The most common form of axially fitted circlips for bores with
                grooves.
              </p>
              <p className="text-[#969696] mb-4 font-[400]">
                The circlip has a large free diameter and gap width,
                consequently it fits more tightly into the groove and provides
                higher and more uniform thrust load capacity. Lugs with holes
                are provided for rapid fitting or removal with circlip pliers.
              </p>
              <p className="text-[#969696] mb-4 font-[400]">
                Standard material: Carbon Spring Steel – Standard Finish:
                Phosphate and Oil.
              </p>
              <p className="text-[#969696] mb-4 font-[400]">
                Most sizes over 170mm are without lugs. Measurements in mm & kN.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SingleCategory;
